// External libraries
import gql from 'graphql-tag';
import { CART_AMOUNTS_FRAGMENT } from '@/lib/graphql';

export const UPDATE_PROFILE_SHIPPING_OPTIONS_MUTATION = gql`
  mutation UpdateProfileShippingOptionsMutation(
    $hideShipping: Boolean!
    $profileOverrideAllowed: Boolean!
    $profileShippingMethods: [ProfileShippingMethodInput]
    $token: String!
  ) {
    updateProfileShippingOptions(
      hideShipping: $hideShipping
      profileOverrideAllowed: $profileOverrideAllowed
      profileShippingMethods: $profileShippingMethods
      token: $token
    ) {
      cart {
        ...CartAmounts
        shippingAddress {
          firstName
          lastName
          line1
          line2
          city
          state
          postalCode
          country
        }
      }
    }
  }

  ${CART_AMOUNTS_FRAGMENT}
`;
